import React, { useState, useEffect, useRef, Suspense } from "react";
import * as ReactDOM from "react-dom";
import ChildCareCentreSlider from "./SearchResultImageSilder";
import Slider from "react-slick";
import axios from "axios";
import ReactGA4 from 'react-ga4';
declare var c4kCore: any;
declare global {
    interface Window {
        SelectedLocation: { [key: string]: any }
        RenderResultList: (elementId: string, props: any) => void;
    }
}

interface PayloadType {
    Action: string
    FeatureData?: string
    Description?: string
}

export const sendGA4Event = (
    eventName: string,
    payload: PayloadType
) => {
    ReactGA4.gtag('event', eventName, payload);
};

const getLatLngGoogle = (address) => {
    return new Promise(async (resolve, reject) => {
        axios
            .get('/api/brandedhub/getlocation', {
                params: {
                    address: encodeURIComponent(address),
                }
            })
            .then(
                (response) => {
                    resolve(response?.data);
                },
                (err) => {
                    reject(err);
                }
            )
            .catch((error) => {
                reject(error);
            });
    });
}

const searchCentreV2 = (params) => {
    return new Promise(async (resolve, reject) => {
        axios
            .get('/api/brandedhub/searchcentresv2', {
                params,
            })
            .then(
                (response) => {
                    resolve(response?.data);
                },
                (err) => {
                    reject(err);
                }
            )
            .catch((error) => {
                reject(error);
            });
    });
}

const ResultList = (props) => {

    const [data, setData] = useState([]);
    const normalObject = Object.assign({}, props.SelectedLocation);
    const [selectedValue, setSelectedValue] = useState(props.selectedValue || "5");
    const [loading, setLoading] = useState(false);

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        className: "carousel-top",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
        ],
        //onInit: () => {
        //    setTimeout(() => {
        //        document.querySelectorAll('.carousel-top .slick-track').forEach((item: any) => {
        //            item.style.transform = 'translate3d(0,0,0)';
        //        })
        //    }, 0)
        //}
    };

    useEffect(() => {
        setData([]);

        const fetchData = async () => {
            try {
                setLoading(true)
                const address = `${normalObject.suburbName}, ${normalObject.postcode}, Australia`;
                getLatLngGoogle(address)
                    .then((res: any) => {

                        const { results } = res
                        const { lat, lng } = results[0].geometry.location;
                        searchCentreV2({
                            key: normalObject.key,
                            postcode: normalObject.postcode,
                            lat,
                            lng,
                            distance: props.selectedValue || 5,
                        })
                            .then((res: any) => {
                                setData(res.Data);

                            })
                            .finally(() => {
                                setLoading(false)
                            })
                    })
                    .catch((error) => {
                        setLoading(false)
                    })

            }
            catch (error) {

            }
        }

        fetchData();
    }, [normalObject.key, props.selectedValue]);

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        sendGA4Event('branded_hub', { Action: 'Radius click', FeatureData: event.target.value })
        window.dispatchEvent(new CustomEvent('dataChanged', {
            detail: {
                selectedValue: event.target.value,
                SelectedLocation: props.SelectedLocation,
            }
        }));
    };

    return (

        <div style={{ background: '#ffffff' }} className="pt-[10px]">
            <style>
                {`
                    .carousel-top .slick-list {
                        display: flex;
                        padding-bottom: 20px;
                    }

                    .carousel-top .slick-dots {
                        position: relative;
                        bottom: 0px;
                    }

                    .carousel-top .slick-dots li {
                        margin: 0px;
                    }

                    .carousel-top .slick-dots li button:before {
                        font-size: 12px;
                    }

                    .carousel-top .slick-list .slick-track {
                        display: flex;
                    }
                    @media screen and (max-width: 480px) {
                        .carousel-top .slick-list .slick-track {
                            gap: 0px;
                        }
                    }

                    .carousel-top .slick-list .slick-track .slick-slide {
                        height: inherit;
                    }

                    .carousel-top .slick-list .slick-track .slick-slide > div {
                        height: 100%
                    }

                    .carousel-top .slick-list .slick-track .slick-slide .item-slider {
                        box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.10), 0px 4px 6px 0px rgba(0, 0, 0, 0.05);
                    }
                `}
            </style>
            <h2
                style={{
                    marginBottom: '25px',
                    color: '#272727',
                    fontSize: '38px'
                }}
                className="font-inter text-center font-bold"
            >
                G8 Centres near {normalObject.suburbName}
            </h2>

            {loading ?
                <span className={`items-center gap-2 w-full justify-center ${loading ? 'flex' : 'hidden'}`}>
                    <img src="/img/navy-spinner.svg" alt="Spinner white dots circle" />
                </span> :
                <>

                    <span style={{
                        display: 'block',
                    }} className="color-[#5E5A6F] mb-[88px] text-center text-[24px]">
                        {data.length === 0 ? "Sorry, there aren't any centres within the search radius." : "We've found the closest childcare centres to you."}

                    </span>
                    {data.length > 0 &&
                        <div className="container ml-auto mr-auto pl-4 pr-4">
                            <div className="m-auto max-w-[938px]">
                                <Slider {...settings} key={normalObject.key}>
                                    {data.map((item, index) => {
                                        console.log('item', item)
                                        const isMultilist = item.ProductSubscription >= 430;
                                        const isPaidSubscription = item.ProductSubscription > 0;
                                        return (
                                            <div className="h-full px-[8px]" key={index}>
                                                <div
                                                    className="item-slider relative h-full overflow-hidden rounded-3xl bg-white"
                                                >
                                                    {/*Favorite Icon*/}
                                                    <div className="flex h-full flex-col justify-between overflow-hidden">
                                                        <div className="overflow-hidden">
                                                            <div className="map-card-gallery overflow-hidden">
                                                                {/*ImageDiv*/}
                                                                <div className="search-result-card-images search-result-image-slider overflow-hidden" style={{ maxHeight: '160px!important' }}>
                                                                    {isMultilist ? (
                                                                        item.GallaryImageIds?.length > 0 ? (
                                                                            <ChildCareCentreSlider centre={item} isCCS={false} lazyFirst={false} />
                                                                        ) : (
                                                                            <div className="aspect-w-7 aspect-h-4 h-full lg:aspect-h-5">
                                                                                <img src="/img/lazy.gif" data-src="/img/generic-profile.jpg" alt="Generic Profile" className="lazy object-cover" />
                                                                            </div>
                                                                        )
                                                                    ) : null}


                                                                </div>
                                                            </div>

                                                            <div className="max-w-md px-4 pt-4">
                                                                <div className="mb-1 font-extrabold text-[17px] text-[#272727]">
                                                                    <a
                                                                        className="cursor-pointer"
                                                                        href={item.ProfileUrl}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            // Assuming c4kCore.analyticsTriggerEvent is a global function
                                                                            if (c4kCore) {
                                                                                c4kCore.analyticsTriggerEvent(e.target, 'Recommended Card');
                                                                            }
                                                                            window.location.href = item.ProfileUrl;
                                                                            sendGA4Event('branded_hub', { Action: 'Centre click', FeatureData: item.Name })
                                                                        }}
                                                                    >
                                                                        {item.Name}
                                                                    </a>
                                                                    {" "}
                                                                    {item.ListingType !== "basic" && (
                                                                        <svg className='inline relative bottom-px' xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                                            <path d="M14.9601 5.82811C14.7096 5.05126 15.5188 3.72342 15.0513 3.07687C14.5793 2.42379 13.0712 2.79035 12.4224 2.31518C11.7801 1.84459 11.6634 0.285248 10.8917 0.0329393C10.1471 -0.210378 9.14534 0.974117 8.32 0.974117C7.49483 0.974117 6.49293 -0.210378 5.74833 0.0329393C4.97659 0.285248 4.85993 1.84459 4.21745 2.31518C3.56884 2.79053 2.06108 2.42362 1.58886 3.07669C1.12136 3.72325 1.93059 5.05144 1.67994 5.82829C1.43805 6.57781 0 7.16953 0 8.00016C0 8.83096 1.43805 9.4225 1.67976 10.172C1.93042 10.9489 1.12119 12.2769 1.58851 12.9234C2.06073 13.5765 3.56849 13.2096 4.21728 13.685C4.85958 14.1554 4.97624 15.7149 5.74816 15.967C6.49275 16.2105 7.49448 15.0258 8.31983 15.0258C9.14517 15.0258 10.1469 16.2105 10.8915 15.967C11.6632 15.7149 11.7799 14.1557 12.4222 13.685C13.071 13.2098 14.5789 13.5767 15.0511 12.9234C15.5188 12.2769 14.7096 10.9489 14.9599 10.172C15.202 9.4225 16.64 8.83096 16.64 8.00016C16.64 7.16953 15.202 6.57781 14.9601 5.82811ZM11.6282 6.28759L7.9632 10.3088C7.95987 10.3125 7.95585 10.315 7.95234 10.3185C7.94394 10.3274 7.93448 10.3344 7.92554 10.3423C7.90733 10.3582 7.88894 10.3725 7.86897 10.3848C7.85881 10.391 7.84865 10.3967 7.83814 10.4023C7.81625 10.4134 7.79365 10.4222 7.77035 10.4296C7.76072 10.4326 7.75161 10.4361 7.7418 10.4386C7.70852 10.4465 7.67472 10.4517 7.64056 10.4517C7.64056 10.4517 7.64039 10.4517 7.64021 10.4517C7.64004 10.4517 7.63969 10.4515 7.63951 10.4515C7.60606 10.4515 7.57278 10.4462 7.54002 10.4384C7.53109 10.4363 7.52251 10.4337 7.51375 10.431C7.4845 10.422 7.4563 10.4104 7.42897 10.3952C7.42547 10.3933 7.42179 10.3928 7.41846 10.3908L5.11216 9.02279C4.90372 8.89919 4.83436 8.6289 4.95714 8.41908C5.07993 8.20944 5.3481 8.13945 5.55671 8.26304L7.55754 9.44983L10.9829 5.69182C11.1463 5.51233 11.4233 5.50052 11.6016 5.66502C11.7797 5.82935 11.7916 6.10828 11.6282 6.28759Z" fill="#5A60EC" />
                                                                        </svg>)}
                                                                </div>
                                                                <div className="mb-4">
                                                                    <span className="text-xs">{item.AddressLine1} {" "} {item.Suburb}</span>
                                                                </div>
                                                                {isPaidSubscription && item.Tags && item.Tags.length > 0 && (
                                                                    <div className="mt-2 flex flex-row flex-wrap gap-2">
                                                                        {item.Tags.map((tag, index) => {
                                                                            let backgroundColor, iconSrc;
                                                                            if (index === 0) {
                                                                                backgroundColor = '#B968FF';
                                                                                iconSrc = '/img/icons/overview-tag-1.svg';
                                                                            } else if (index === 1) {
                                                                                backgroundColor = '#908DFF';
                                                                                iconSrc = '/img/icons/overview-tag-2.svg';
                                                                            } else {
                                                                                backgroundColor = '#876DEE';
                                                                                iconSrc = '/img/icons/overview-tag-3.svg';
                                                                            }

                                                                            return (
                                                                                <div
                                                                                    key={index}
                                                                                    className="font-small flex items-center justify-center gap-1 rounded-full border px-4 py-1 text-center"
                                                                                    style={{ backgroundColor, color: 'white!important', fontSize: '0.60rem' }}
                                                                                >
                                                                                    <div>
                                                                                        <img src={iconSrc} alt="Tag Icon" />
                                                                                    </div>
                                                                                    <div>{tag}</div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <div className="max-w-xs px-4 pb-6">
                                                                <div className="mr-12 flex flex-row">
                                                                    <div className="flex flex-wrap items-center gap-2 text-xs leading-none">

                                                                        {/*<!--Reveiws-->*/}
                                                                        {item.RatingAverageCombined && (
                                                                            <a
                                                                                className="recommended-card-detail-item flex-wrap"
                                                                                onClick={(e) => {
                                                                                    c4kCore.analyticsTriggerEvent(e.target, 'Recommended Card')
                                                                                    sendGA4Event('branded_hub', { Action: 'Centre click', FeatureData: item.Name })
                                                                                }}
                                                                                href={`${item.ProfileUrl}#reviews`}
                                                                            >
                                                                                <span className="flex flex-row items-center">
                                                                                    {Array.from({ length: Math.round(item.RatingAverageCombined) }).map((_, index) => (
                                                                                        <img key={index} src="/img/icons/gold-star.svg" alt="Gold star" width="12" height="12" />
                                                                                    ))}
                                                                                    {Array.from({ length: 5 - Math.round(item.RatingAverageCombined) }).map((_, index) => (
                                                                                        <img key={index} src="/img/icons/gray-star.svg" alt="Gray star" width="12" height="12" />
                                                                                    ))}
                                                                                </span>
                                                                                <span className="font-bold">{item.RatingAverageCombined.toFixed(1)}</span>
                                                                                <span>
                                                                                    {item.ReviewCountCombined} Review{item.ReviewCountCombined > 1 ? 's' : ''}
                                                                                </span>
                                                                            </a>
                                                                        )}


                                                                        {/*<!--NQS/ERO Rating-->*/}
                                                                        {item.CentreQualityAreaRatingsModel.QualtiyAreaRatingLabels ? (
                                                                            <a
                                                                                className="recommended-card-detail-item search-result-card-quality-rating"
                                                                                onClick={(e) => {
                                                                                    c4kCore.analyticsTriggerEvent(e.target, 'Recommended Card')
                                                                                    sendGA4Event('branded_hub', { Action: 'Centre click', FeatureData: item.Name })
                                                                                }}
                                                                                href={`${item.ProfileUrl}#nqs`}
                                                                            >
                                                                                <span className="font-bold">{item.NQRatingOverall}</span>
                                                                                <span>NQS</span>
                                                                            </a>

                                                                        ) : null}


                                                                        {/*<!--Vacancies-->*/}
                                                                        <a
                                                                            className="recommended-card-detail-item search-result-card-vacancies"
                                                                            onClick={(e) => {
                                                                                c4kCore.analyticsTriggerEvent(e.target, 'Recommended Card')
                                                                                sendGA4Event('branded_hub', { Action: 'Centre click', FeatureData: item.Name })
                                                                            }}
                                                                            href={`${item.ProfileUrl}#fees`}
                                                                        >
                                                                            {item.HasVacancies ? (
                                                                                <span className="flex flex-row items-center">
                                                                                    <svg style={{ width: '12px', height: '12px' }}>
                                                                                        <use xlinkHref="/img/icons/srp-profile-core-sprite.svg#green-circle-tick" />
                                                                                    </svg>
                                                                                </span>
                                                                            ) : (
                                                                                <span>No</span>
                                                                            )}
                                                                            <span>Vacancies</span>
                                                                        </a>


                                                                        {/*<!--Avg Price-->*/}
                                                                        {item.DailyAverageFee > 0 && (
                                                                            <a
                                                                                className="recommended-card-detail-item search-result-card-aveprice"
                                                                                onClick={(e) => {
                                                                                    c4kCore.analyticsTriggerEvent(e.target, 'Recommended Card')
                                                                                    sendGA4Event('branded_hub', { Action: 'Centre click', FeatureData: item.Name })
                                                                                }}
                                                                                href={`${item.ProfileUrl}#fees`}
                                                                            >
                                                                                <span className="font-bold">
                                                                                    {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.DailyAverageFee)}
                                                                                </span>
                                                                                <span>avg. price/day</span>
                                                                            </a>
                                                                        )}

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        )
                                    })}

                                </Slider>
                            </div>
                        </div>
                    }


                </>
            }
            <div className="mb-[30px] mt-[30px] flex w-full items-center justify-center gap-2 md:mt-[70px] md:mb-[90px]">
                <p className="font-semibold text-[#484554] text-[16px]">Search Radius</p>
                <select name="radius" value={props.selectedValue || "5"} onChange={handleChange} style={{
                    borderRadius: '8px'
                }}>
                    <option value="5">Up to 5km</option>
                    <option value="10">Up to 10km</option>
                    <option value="15">Up to 15km</option>
                </select>
            </div>
        </div>

    )
}

window.RenderResultList = (elementId, props) => {
    ReactDOM.render(<ResultList {...props} />, document.getElementById(elementId));
};

window.addEventListener('dataChanged', (event: any) => {
    ReactDOM.render(<ResultList {...event.detail} />, document.getElementById('g8-centre-near-bottom'));
    ReactDOM.render(<ResultList {...event.detail} />, document.getElementById('g8-centre-near-top'));
});